import React from 'react';
import './AppHeader.css';

export function AppHeader() {
  return (
    <header className="app-header">
      <div className="logo">
        <img src="/logo-my-crypto-card.svg" alt="My Crypto Card" className="logo-image" />
      </div>
    </header>
  );
}
